export let readFile = file => {
  let reader = new FileReader()

  return new Promise((resolve, reject) => {
    reader.onload = () => {
      resolve(reader.result)
    }

    reader.onerror = () => {
      reader.abort()
      reject(new DOMException("Problem parsing input file."))
    }

    reader.readAsDataURL(file)
  })
}
